import { Component, OnDestroy, Inject, OnInit } from '@angular/core';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
} from '@richardlt/ng2-semantic-ui';
import { DOCUMENT } from '@angular/common';
interface ISelectionMethodModalContext {
  question: string;
  title?: string;
}
@Component({
  selector: 'app-selection-method-modal',
  template: `
    <h3 id="header" class="ui primary header">
      {{ modal.context.title }}
      <i class="link times icon" (click)="modal.deny(undefined)"></i>
    </h3>

    <div class="content">
      <div class="ui basic segment">
        <div class="ui form">
          <div class="field">
            <label>Selection Method</label>
            <sui-select
              class="selection"
              [options]="options"
              [isSearchable]="searchable"
              #select
            >
              <sui-select-option
                *ngFor="let option of select.filteredOptions"
                [value]="option"
              >
              </sui-select-option>
            </sui-select>
          </div>
          <div class="inline text-center" appMargin marginT="5">
            <button
              class="ui  basic primary button"
              (click)="modal.deny(undefined)"
            >
              Cancel
            </button>
            <button
              class="ui  primary button"
              (click)="modal.approve(undefined)"
              autofocus
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./appropriation-modal.component.scss'],
})
export class SelectionMethodModalComponent implements OnInit, OnDestroy {
  options = ['Active', 'Rejected'];
  searchable: boolean = true;
  constructor(
    @Inject(DOCUMENT) private document,
    public modal: SuiModal<ISelectionMethodModalContext, void, void>
  ) {}
  ngOnInit() {
    this.document.body.classList.remove('panel');
  }
  // s
  ngOnDestroy(): void {
    this.document.body.classList.add('panel');
  }
}

export class SelectionMethodModal extends ComponentModalConfig<
  ISelectionMethodModalContext,
  void,
  void
> {
  constructor(
    title: string,
    question: string,
    size: ModalSize = ModalSize.Small
  ) {
    super(SelectionMethodModalComponent, { title, question });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
